import React from "react";

/**
 * The Catalyst Table crest — the founder's original engraved artwork
 * (two interlocking bentwood chairs). Uses a charcoal version for light
 * backgrounds and an ivory version for dark backgrounds.
 */
export const CrestLogo = ({ className = "w-16 h-16", variant = "dark", color }) => {
  const src = variant === "light" ? "/crest-light.png" : "/crest-dark.png";
  return (
    <img
      src={src}
      alt="The Catalyst Table crest"
      className={`${className} object-contain`}
      data-testid="crest-logo-svg"
    />
  );
};

export default CrestLogo;
